import { IMec } from './filters'

export class Geo {
    data: IMec[]
    toggleNoDetects: boolean

    constructor(mecsFiltered: IMec[], toggleNoDetects: boolean) {
        this.data = mecsFiltered
        this.toggleNoDetects = toggleNoDetects
    }
}